import { render, staticRenderFns } from "./component-imgs.vue?vue&type=template&id=5c7c5b94&scoped=true"
import script from "./component-imgs.vue?vue&type=script&lang=js"
export * from "./component-imgs.vue?vue&type=script&lang=js"
import style0 from "./component-imgs.vue?vue&type=style&index=0&id=5c7c5b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7c5b94",
  null
  
)

export default component.exports